import { Link, useLocation } from 'react-router-dom';
import { useRole } from '@/contexts/RoleContext';
import { useTracking } from '@/hooks/useTracking';

/**
 * Barre de navigation — reprise du prototype : fond translucide flouté,
 * icône pleine sur l'onglet actif, cinq onglets pour le conducteur.
 */
const driverTabs = [
  { path: '/',         icon: 'ri-home-5-line',        on: 'ri-home-5-fill',        label: 'Accueil' },
  { path: '/tracking', icon: 'ri-route-line',         on: 'ri-route-fill',         label: 'Trajets' },
  { path: '/reports',  icon: 'ri-bar-chart-box-line', on: 'ri-bar-chart-box-fill', label: 'Rapports' },
  { path: '/expenses', icon: 'ri-receipt-line',       on: 'ri-receipt-fill',       label: 'Dépenses' },
  { path: '/profile',  icon: 'ri-user-line',          on: 'ri-user-fill',          label: 'Profil' },
];

const fleetTabs = [
  { path: '/',         icon: 'ri-home-5-line',        on: 'ri-home-5-fill',        label: 'Accueil' },
  { path: '/fleet',    icon: 'ri-group-line',         on: 'ri-group-fill',         label: 'Flotte' },
  { path: '/reports',  icon: 'ri-bar-chart-box-line', on: 'ri-bar-chart-box-fill', label: 'Rapports' },
  { path: '/expenses', icon: 'ri-receipt-line',       on: 'ri-receipt-fill',       label: 'Dépenses' },
  { path: '/profile',  icon: 'ri-user-line',          on: 'ri-user-fill',          label: 'Profil' },
];

export default function BottomNavigation() {
  const { pathname } = useLocation();
  const { role } = useRole();
  // Un trajet en cours doit se voir depuis n'importe quel écran : sinon on
  // l'oublie, et on le laisse tourner toute la soirée.
  const { isTracking } = useTracking();

  const tabs = role === 'fleet_manager' ? fleetTabs : driverTabs;
  const accent = 'var(--brand)';

  return (
    <div
      style={{
        position: 'absolute', left: 0, right: 0, bottom: 0, zIndex: 30,
        padding: '8px 6px calc(var(--safe-b) + 10px)',
        background: 'var(--nav)', backdropFilter: 'blur(18px)',
        borderTop: '1px solid var(--border)', display: 'flex',
      }}
    >
      {tabs.map((t) => {
        const active = pathname === t.path;
        const color = active ? accent : 'var(--faint)';
        return (
          <Link
            key={t.path}
            to={t.path}
            style={{
              flex: 1, minHeight: 48, display: 'flex', flexDirection: 'column',
              alignItems: 'center', gap: 3, padding: '5px 0', textDecoration: 'none',
              position: 'relative',
            }}
          >
            <i className={active ? t.on : t.icon} style={{ fontSize: 22, color }}></i>
            <span style={{ fontSize: 10, fontWeight: 600, color }}>{t.label}</span>
            {isTracking && t.path === '/tracking' && !active && (
              <span
                aria-label="Trajet en cours"
                style={{
                  position: 'absolute', top: 3, marginLeft: 22,
                  width: 8, height: 8, borderRadius: 99, background: 'var(--ok)',
                  animation: 'alPulse 1.4s ease-in-out infinite',
                }}
              />
            )}
          </Link>
        );
      })}
    </div>
  );
}
